<template>
  <div class="productCase-container">
    <commonHeader>
      <img slot="content" class="banner" :src="bannerImg | imgFilter" />
      <banner-content
        slot="content"
        title="产品案例"
        en-title="PRODUCT CASES"
        content="拥有丰富的项目经验，以最短的时间开发出高性能的产品<br/>用自主开发的软件框和前沿技术研发而成<br/>保持了原有的稳定高效的特点，更提高了框架的安全性和可扩展性"
      />
    </commonHeader>
    <case-show ref="caseShow1" :type="1" style="padding-top: 100px;">
      <common-title
        title="PRODUCTS"
        subTitle="CASES"
        slot="title"
        contentTitle="产品案例"
        content="专注政企软件、Web网站、移动端APP、小程序、to B型产品、to C型产品等多个领域的设计与研发<br/>提供有效的解决方案，每个项目专属定制，使政企资源在各方面得到合理配置"
      />
    </case-show>
    <case-show ref="caseShow2" :type="2" >
      <common-title
        slot="title"
        title="WEBSITE"
        subTitle="DESIGN"
        contentTitle="网页设计"
        content="致力于响应式网站开发,H5自适应网站建设,提供高端网站解决方案,为客户提供更好的视觉设计体验"
      />
    </case-show>
    <case-show ref="caseShow3" :type="3">
      <common-title
        slot="title"
        title="MOBILE"
        subTitle="GAMES"
        contentTitle="游戏开发"
        content="依托今日头条、微信、百度、腾讯等流量平台开发了女性故事对话类、3D 休闲类、格斗、MOBA 等类"
      />
    </case-show>
    <partner-show></partner-show>
    <back-up></back-up>
  </div>
</template>
<script>
import commonHeader from "@/components/commonHeader.vue";
import commonTitle from "@/components/commonTitle.vue";
import bannerContent from "@/components/bannerContent.vue";
import bannerTap from "./components/bannerTap.vue";
import caseShow from "./components/caseShow.vue";
import partnerShow from "./components/partnerShow.vue";
import backUp from "./components/backTop";
import { mapActions, mapGetters } from "vuex";
export default {
  data() {
    return {
      tapList: [
        {
          id: 1,
          title: "软件外包",
          subTitle: "专注于各个领域的软件开发、信息化定制"
        },
        {
          id: 2,
          title: "网页设计",
          subTitle: "原创定制 , 优秀的制作团队与品牌设计"
        },
      ]
    };
  },
  components: {
    commonHeader,
    commonTitle,
    bannerContent,
    bannerTap,
    "case-show": caseShow,
    partnerShow,
    "back-up":backUp
  },

  methods: {
    selectSection(item) {
      this.$refs["caseShow" + item.id].scroll();
    },
    ...mapActions("banner", ["getBanner"]),
    init(){
      this.$refs.tapBar.sticky();
    }
  },
  computed: {
    ...mapGetters("banner", ["banner"]),
    bannerImg() {
      let arr = this.banner(3);
      return arr.length ? arr[0].carousel_image : "";
    }
  },
  created() {
    if (!this.banner(3).length) this.getBanner(3);
    console.log(this.bannerImg);
  }
};
</script>
<style lang="scss" scoped>
@import url("~@/assets/css/common.scss");
.productCase-container {
  width: 100%;
  .banner {
    width: 100%;
  }
}
</style>
